module.exports = __webpack_public_path__ + "static/media/guide.5b44eff8.pdf";